// extracted by mini-css-extract-plugin
export var capabilites_images = "Capabilities-module--capabilites_images--5Ekhx";
export var capabilites_images_2 = "Capabilities-module--capabilites_images_2--+Cgkj";
export var capabilities_header = "Capabilities-module--capabilities_header--ddDYu";
export var caret_icon = "Capabilities-module--caret_icon--Sa502";
export var more_here = "Capabilities-module--more_here--wJBwx";
export var squarehook_logo = "Capabilities-module--squarehook_logo--ePNpM";